export default "__VITE_ASSET__2e80c217__"